/// <amd-module name="VSSUI/Components/IdentityCard/GitHubCard" />
import * as React from "react";
import * as Resources from "VSSUI/Resources.Persona";

import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { CardContactLine } from "./CardContactLine";
import { IContactCardProps } from "./ContactCard.Props";

export const GitHubCard: React.FunctionComponent<IContactCardProps> = (props: IContactCardProps) => {
    const { identity } = props;
    const { displayName, mail, mailNickname } = identity;

    return (
        <div className={"bolt-identity-default-card-without-header bolt-identity-card-content"}>
            <div className="flex-row">
                <Persona className="bolt-identity-card-persona-main" size={PersonaSize.size72} identity={identity} />
                <div className="flex-column flex-grow bolt-identity-card-name">
                    <div className="word-wrap title-s">{displayName}</div>
                    {mailNickname === "" ? undefined : <div className="text-ellipsis">{mailNickname}</div>}
                    {mail === "" ? undefined : <div className="text-ellipsis">{mail}</div>}
                </div>
            </div>

            <div>
                {(mail || mailNickname) && (
                    <div className="bolt-identity-default-card-info-wrapper">
                        <hr className="bolt-identity-card-hr" />
                        <div className="bolt-identity-default-card-header-wrapper">
                            <div className="bolt-identity-default-card-header pointer bolt-profile-card-tab-element">
                                {Resources.IdentityCardContact}
                            </div>
                        </div>

                        <div className="bolt-identity-default-card-contact-info-container">
                            {mailNickname && <CardContactLine iconName="GitHubLogo" content={"thomabr"} />}
                            {mail && <CardContactLine iconName="Mail" content={mail} link={`mailto:${mail}`} />}
                            {mail && <CardContactLine iconName="Chat" content={Resources.IdentityCardStartChat} link={`sip:${mail}`} />}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
